/**
 * Benefits Carousel — oddit-section-benefits
 * Horizontal scrolling carousel with snap, arrow navigation, and dot indicators.
 */
(function () {
  'use strict';

  /**
   * Initialise a single Benefits Carousel section.
   * @param {HTMLElement} section – the .oddit-section-benefits root element
   * @returns {Function} cleanup – call to tear down listeners
   */
  function initSection(section) {
    var track = section.querySelector('.oddit-section-benefits__carousel-track');
    var prevBtn = section.querySelector('.oddit-section-benefits__carousel-arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-benefits__carousel-arrow--next');
    var indicatorContainer = section.querySelector('.oddit-section-benefits__carousel-indicators');

    if (!track || !prevBtn || !nextBtn || !indicatorContainer) return function () {};

    var cards = Array.from(track.querySelectorAll('.oddit-section-benefits__card'));
    if (!cards.length) return function () {};

    /* ---- Helpers ---- */

    function getVisibleCount() {
      var trackWidth = track.clientWidth;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      return Math.max(1, Math.floor((trackWidth + gap) / (cardWidth + gap)));
    }

    function getTotalPages() {
      return Math.max(1, cards.length - getVisibleCount() + 1);
    }

    function getCurrentPage() {
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      return Math.round(track.scrollLeft / (cardWidth + gap));
    }

    /* ---- Dot Indicators ---- */

    function buildDots() {
      indicatorContainer.innerHTML = '';
      var totalPages = getTotalPages();
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'oddit-section-benefits__carousel-dot';
        dot.setAttribute('aria-label', 'Go to benefit ' + (i + 1));
        dot.setAttribute('type', 'button');
        if (i === 0) dot.classList.add('oddit-section-benefits__carousel-dot--active');
        dot.addEventListener('click', (function (page) {
          return function () { scrollToPage(page); };
        })(i));
        indicatorContainer.appendChild(dot);
      }
    }

    function updateDots() {
      var page = getCurrentPage();
      var dots = indicatorContainer.querySelectorAll('.oddit-section-benefits__carousel-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('oddit-section-benefits__carousel-dot--active', i === page);
      });
      updateArrowColors(page);
    }

    function updateArrowColors(page) {
      var totalPages = getTotalPages();
      var prevSvgPath = prevBtn.querySelector('path');
      var nextSvgPath = nextBtn.querySelector('path');
      var prevColor = page <= 0 ? '#9E9E9E' : '#000000';
      var nextColor = page >= totalPages - 1 ? '#9E9E9E' : '#000000';
      if (prevSvgPath) prevSvgPath.setAttribute('fill', prevColor);
      if (nextSvgPath) nextSvgPath.setAttribute('fill', nextColor);
    }

    /* ---- Scroll ---- */

    function scrollToPage(page) {
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      var target = page * (cardWidth + gap);
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function onPrevClick() {
      var page = getCurrentPage();
      if (page > 0) scrollToPage(page - 1);
    }

    function onNextClick() {
      var page = getCurrentPage();
      if (page < getTotalPages() - 1) scrollToPage(page + 1);
    }

    prevBtn.addEventListener('click', onPrevClick);
    nextBtn.addEventListener('click', onNextClick);

    /* ---- Scroll listener for dot sync ---- */

    var scrollTimeout;
    function onTrackScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateDots, 80);
    }
    track.addEventListener('scroll', onTrackScroll, { passive: true });

    /* ---- Resize ---- */

    var resizeTimeout;
    function onWindowResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        buildDots();
        updateDots();
      }, 150);
    }
    window.addEventListener('resize', onWindowResize);

    /* ---- Init ---- */

    buildDots();
    updateArrowColors(0);

    /* ---- Cleanup ---- */

    return function cleanup() {
      prevBtn.removeEventListener('click', onPrevClick);
      nextBtn.removeEventListener('click', onNextClick);
      track.removeEventListener('scroll', onTrackScroll);
      window.removeEventListener('resize', onWindowResize);
      clearTimeout(scrollTimeout);
      clearTimeout(resizeTimeout);
    };
  }

  /* ---- Boot all instances on the page ---- */

  var cleanups = {};

  function initAll() {
    document.querySelectorAll('.oddit-section-benefits').forEach(function (el) {
      var id = el.closest('[id]') ? el.closest('[id]').id : el.id;
      if (id && !cleanups[id]) {
        cleanups[id] = initSection(el);
      }
    });
  }

  initAll();

  /* ---- Theme-editor events ---- */

  document.addEventListener('shopify:section:load', function (evt) {
    var container = evt.target;
    var section = container.querySelector('.oddit-section-benefits');
    if (!section) return;
    var id = container.id || section.id;
    if (id) {
      cleanups[id] = initSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var id = evt.target.id;
    if (id && typeof cleanups[id] === 'function') {
      cleanups[id]();
      delete cleanups[id];
    }
  });
})();